var _rect, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchOn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 32,
    viewBox: "0 0 60 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 32,
    rx: 16,
    fill: "#76BA18"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 16,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7695 20.1406C14.2129 20.1406 15.7305 18.459 15.7305 15.7754V15.7637C15.7305 13.0859 14.207 11.4043 11.7695 11.4043C9.33789 11.4043 7.80859 13.0801 7.80859 15.7637V15.7754C7.80859 18.4648 9.33203 20.1406 11.7695 20.1406ZM11.7695 18.9805C10.1641 18.9805 9.14453 17.7441 9.14453 15.7754V15.7637C9.14453 13.7949 10.1699 12.5645 11.7695 12.5645C13.375 12.5645 14.3887 13.8008 14.3887 15.7637V15.7754C14.3887 17.7266 13.3926 18.9805 11.7695 18.9805ZM16.9844 20H18.2852V13.7363H18.3203L22.6738 20H23.8809V11.5449H22.5801V17.7969H22.5449L18.1973 11.5449H16.9844V20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOn);
export default __webpack_public_path__ + "static/media/switch-on.ef3e3dfd.svg";
export { ForwardRef as ReactComponent };